import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=4fcd65fe&scoped=true&"
import script from "./BaseText.vue?vue&type=script&lang=ts&"
export * from "./BaseText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd65fe",
  null
  
)

export default component.exports